module.exports = __webpack_public_path__ + "media/ACCESS_LOCKED.af057b6d.mp3";